import script from "./ChoicesSelectMultiple.vue?vue&type=script&setup=true&lang=js"
export * from "./ChoicesSelectMultiple.vue?vue&type=script&setup=true&lang=js"

import "./ChoicesSelectMultiple.vue?vue&type=style&index=0&id=2e57a7fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e57a7fc"]])

export default __exports__